import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

export type ApproveDailyReportFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: ApproveDailyReportFormProps) => {
  const [
    fnApproveDailyReportForm,
    { loading }
  ] = ds.useApproveDailyReport();
  const form = ds.useFormState(props.id);
  const handleSubmit = async (id: string) => {

    await fnApproveDailyReportForm(id);
    props.handleClose();
  };


  return (
    <FormBaseLayout.FC
      title=''
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState.id);
      }}
      cancelButtonText='Cancel'
      successButtonText='Approve Report'
      isLoading={loading}
    >
      {/* ADD FIELDS */}
      <></>
    </FormBaseLayout.FC>

  );
};
